$(document).ready(function () {
  var $slider = $('.header-main-sec');

  function isMobileViewport() {
    return window.innerWidth <= 768; // adjust as per your breakpoint
  }

  if ($slider.length && isMobileViewport()) {
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  } else {
    console.log("Slider not initialized — either not found or not mobile.");
  }
});
